export default {
  root: {},
  modal: {
    zIndex: '1299 !important',
  },
};
